<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="isLoading" style="margin: 30vh">
              <loading
                :active.sync="isLoading"
                :can-cancel="false"
                loader="dots"
                color="rgb(20, 80, 144)"
                :width="100"
                :is-full-page="false"
              >
              </loading>
            </div>
            <div class="row" v-else>
              <div class="col-sm-6 col-md-3 text-center">
                <img
                  v-if="user.picture != null"
                  class="img-fluid"
                  :src="image"
                  style="border-radius: 10px; border: 1px solid lightgray"
                  alt=""
                />
                <img
                  v-else
                  src="@/assets/images/users/default.svg"
                  style="border-radius: 10px"
                  alt=""
                />
                <div class="text-center">
                  <b-modal
                    id="modal-lg"
                    size="md"
                    :title="$t('pages.users.cropper.title')"
                    title-class="font-18"
                    hide-footer
                  >
                    <p class="text-muted text-center">
                      {{ $t("pages.users.cropper.deposit") }} :
                    </p>
                    <div class="text-center">
                      <vue-avatar
                        :width="300"
                        :height="300"
                        :rotation="rotation"
                        :borderRadius="borderRadius"
                        :scale="scale"
                        ref="vueavatar"
                        @vue-avatar-editor:image-ready="onImageReady"
                      >
                      </vue-avatar>
                      <br />
                      <label>
                        Zoom : {{ scale }}x
                        <br />
                        <input
                          type="range"
                          min="1"
                          max="3"
                          step="0.02"
                          v-model.number="scale"
                        />
                      </label>
                    </div>
                    <form enctype="multipart/form-data">
                      <div class="col-10 mb-2 mx-auto">
                        <div class="row">
                          <br />
                          <div class="col-md-12 col text-center">
                            <button
                              v-if="!this.isLoadingProfile"
                              type="submit"
                              class="btn btn-primary btn-block text-center"
                              @click.prevent="updatePicture"
                            >
                              {{ $t("pages.users.save") }}
                            </button>
                            <button
                              class="btn btn-primary btn-block text-center"
                              type="button"
                              v-else
                              disabled
                            >
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              {{ $t("pages.users.update") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </b-modal>
                </div>
                <div class="row mt-2">
                  <div class="col-md-12">
                    <a class="text-primary" v-b-modal.modal-lg>
                      <i class="bx bxs-edit mr-2 text-primary"></i>
                      <b>{{ $t("pages.profile.picture.title") }}</b>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-9">
                <div class="mb-4">
                  <form @submit.prevent="onSubmit">
                    <div class="row mb-12">
                      <div class="col">
                        <label>{{ $t("pages.users.firstname") }}: </label>
                        <input
                          type="text"
                          v-model.trim="user.firstname"
                          class="form-control"
                          :placeholder="$t('pages.users.firstname')"
                          required
                        />
                      </div>
                      <div class="col-md-6">
                        <label>{{ $t("pages.users.lastname") }}: </label>
                        <input
                          type="text"
                          v-model.trim="user.lastname"
                          class="form-control"
                          :placeholder="$t('pages.users.lastname')"
                          required
                        />
                      </div>
                    </div>
                    <div class="row mt-4 mb-12">
                      <div class="col-md-6">
                        <label for="adress">{{ $t("pages.users.mail") }}</label>
                        <input
                          id="adress"
                          v-model.trim="user.email"
                          disabled
                          class="form-control"
                          :placeholder="$t('pages.users.mail')"
                          required
                        />
                      </div>
                      <div class="col-md-6">
                        <label>{{ $t("pages.users.phone") }} </label>
                        <input
                          type="number"
                          v-model.number="user.phone"
                          class="form-control"
                          :placeholder="$t('pages.users.phone')"
                          required
                        />
                      </div>
                      <br />
                      <div class="col-md-12 mt-4">
                        <label for="adress">{{ $t("pages.users.adress") }}</label>
                        <textarea
                          id="adress"
                          v-model.trim="user.address"
                          class="form-control"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                    <div class="mt-4 mb-3">
                      <div class="row">
                        <div class="col-12 text-left">
                          <button
                            v-if="!this.isLoading"
                            type="submit"
                            class="col-3 btn btn-primary"
                          >
                            {{ $t("pages.users.update") }}
                          </button>
                          <button
                            class="col-3 btn btn-primary"
                            type="button"
                            v-else
                            disabled
                          >
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {{ $t("pages.users.update") }}
                          </button>
                          <router-link
                            :to="{ name: 'default' }"
                            class="col-3 btn btn-light ml-2"
                            >{{ $t("pages.users.cancel") }}</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { VueAvatar } from "vue-avatar-editor-improved";
import Loading from "vue-loading-overlay";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex";
import userApi from "../../../api/userApi";

export default {
  name: "Profile",
  components: {
    Layout,
    PageHeader,
    VueAvatar,
    Loading,
  },
  data() {
    return {
      title: "pages.profile.title",
      imageLink: "",
      isLoading: false,
      isLoadingProfile: false,
      profile: {
        picture: null,
        imageCropped: null,
      },
      user: {},
      image: null,
      renderComponent: true,
      mime_type: "",
      rotation: 0,
      scale: 1,
      borderRadius: 0,
    };
  },

  computed: {
    process() {
      return process.env.VUE_APP_IMAGE_URL;
    },
    // image() {
    //   let user = JSON.parse(localStorage.getItem('user'));
    //   return `${location.protocol + "//" + location.hostname + "/api"}/profile/${user.id}`;
    // },
  },
  methods: {
    ...mapActions([
      "updateUserProfile",
      "getUserById",
      "updateUserPicture",
      "getUser",
      "clear",
    ]),
    closeModal() {
      this.profile = {
        picture: null,
      };
    },

    onSubmit() {
      this.isLoading = true;

      this.updateUserProfile(this.user).then((updated) => {
        if (updated) {
          this.isLoading = false;
          this.$toasted.success(this.$t("pages.profile.updated"));
          this.forceRender();
        } else {
          this.$toasted.error(this.$t("pages.unauthorized.error_0"));
          this.isLoading = false;
        }
      });
    },
    updatePicture() {
      if (this.$refs.vueavatar.changed) {
        this.isLoadingProfile = true;
        this.imageCropped = this.$refs.vueavatar.getImage().toDataURL();
        const formData = new FormData();
        this.$refs.vueavatar.getImage().toBlob((blob) => {
          formData.append("picture", blob, "image.png");
          formData.append("type", this.mime_type);

          this.updateUserPicture(formData)
            .then((response) => {
                this.getPicture();
                this.profile.picture = null;
                this.$toasted.success(this.$t("pages.profile.picture.updated"));
                this.closeModal();
                this.isLoadingProfile = false;
                this.user = response.data.user;
            })
            .catch(() => {
              this.isLoadingProfile = false;
              this.$toasted.error(this.$t("pages.unauthorized.error_0"));
            });
        }, this.mime_type);
      } else {
        this.$toasted.error(this.$t("pages.profile.picture.error"));
      }
    },
    forceRender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    loadImage(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    onImageReady() {
      this.scale = 1;
      this.rotation = 0;
    },
    getPicture() {
      let user = JSON.parse(localStorage.getItem('user'));
      userApi.getPicture(user.id).then(response => {
        const myBlob = response.data;
        this.image = URL.createObjectURL(myBlob);
      })
    }
  },
  created() {
    this.getPicture();
    this.isLoading = true;
    userApi
      .retrieve()
      .then((res) => {
        this.user = res.data.user;
        this.isLoading = false;
      })
      .catch(() => {
        this.$toasted.error(this.$t("pages.unauthorized.server_error"));
        this.isLoading = false;
      });
  },
};
</script>
